import { ToggleButtonGroup } from '@mui/material';
import { styled } from '@mui/material/styles';

import { fastTransition } from '../../../../styles/tokens';

/** Segmented control: neutral, selected state = surface-hover, never the brand. */
export const StyledViewModeToggle = styled(ToggleButtonGroup)(({ theme }) => {
  const { color, radius, motion } = theme.palette.tokens;
  return {
    height: '40px',
    padding: '3px',
    gap: '2px',
    borderRadius: `${radius.control}px`,
    border: `1px solid ${color.borderHairline}`,
    backgroundColor: color.surface,
    '& .MuiToggleButtonGroup-grouped': {
      border: 0,
      borderRadius: `${radius.control - 2}px !important`,
      margin: 0,
    },
    '& .MuiToggleButton-root': {
      padding: '0 10px',
      color: color.textSecondary,
      transition: fastTransition(motion, 'background-color', 'color'),
      '& .material-symbols-outlined': {
        fontSize: '20px',
      },
      '&:hover': {
        color: color.textPrimary,
        backgroundColor: color.surfaceHover,
      },
      '&.Mui-selected': {
        color: color.textPrimary,
        backgroundColor: color.surfaceHover,
        '&:hover': {
          backgroundColor: color.n150,
        },
      },
      '&.Mui-disabled': {
        opacity: 0.4,
      },
      '&.Mui-focusVisible': {
        boxShadow: color.focusRing,
      },
    },
  };
});
